module.exports = __webpack_public_path__ + "static/media/runwhite.0e71eff8.bin";